export default __webpack_public_path__ + "static/media/sd-event2.16f20740.png";